import { render, staticRenderFns } from "./subBtnBox.vue?vue&type=template&id=6c750b1a&scoped=true&"
import script from "./subBtnBox.vue?vue&type=script&lang=js&"
export * from "./subBtnBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c750b1a",
  null
  
)

export default component.exports